import { useMemo } from 'react';
import { PumoModuleFragment } from '../../generated/types';
import { useIsAmexCustomer } from '../../hooks/useIsAmexCustomer';

const isBannerModule = (module: PumoModuleFragment) =>
  module.name?.trim().toLowerCase() === 'banner';

const isAmexBannerModule = (module: PumoModuleFragment) =>
  module.name?.trim().toLowerCase() === 'amex banner';

/**
 * Switches the Banner module with the AmEx Banner module for AmEx Centurion customers.
 */
export const useSwitchAmexModules = (modules: PumoModuleFragment[]) => {
  const isAmexCustomer = useIsAmexCustomer();
  const hasAmexBanner = modules.some(isAmexBannerModule);

  return useMemo(
    () =>
      modules.filter(module =>
        isAmexCustomer && hasAmexBanner ? !isBannerModule(module) : !isAmexBannerModule(module)
      ),
    [modules, isAmexCustomer, hasAmexBanner]
  );
};
